import "./Filter.html";
import "./Filter.scss";

import type { IControllerConstructor, Injectable } from "angular";

export class FilterComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        // tslint:disable:object-literal-sort-keys
        this.bindings = {
            debounce: "<?",
            filterTerm: "=ngModel", // Will hide title block if caption is not set
            placeholder: "<?",
        };
        this.templateUrl = "/App/Modules/Gui/Components/Filter/Filter.html";
    }
}
